.listBorder {
  display: flex;
  flex-direction: column;
  border: 8px grey dashed;
  flex: 1;
}

.list {
  display: flex;
  flex-direction: column;
  flex: 1;
  box-sizing: content-box;
}

.listRow {
  display: flex;
  align-items: center;
  padding: 4px 0;
  gap: 8px;
}

.listRow:hover {
  background: #fff3;
}

.listRow > div {
  display: flex;
  align-items: center;
}

.name {
  min-width: 80px;
}

.listRow select {
  min-width: 128px;
}

.dropTarget {
  background: #fff5;
}

.dragLine {
  height: 1px;
  background: white;
}

.error {
  color: red;
}

.hidden {
  visibility: hidden;
}

.attachmentPopover {
  position-area: bottom;
  margin: 0;
  border: 0;
  padding: 0;
}

.attachmentList {
  display: flex;
  flex-direction: column;
}

.attachmentList button {
  border: none;
  background: none;
  color: inherit;
}

.attachmentList button:hover {
  background: var(--link-color);
}
